module.exports = __webpack_public_path__ + "img/图.676a68d4.webp";